// src/pages/Menu.jsx
import "./Menu.css";
import React from "react";
import MenuHero from "../../components/MenuHero/MenuHero";
import FoodMenu from "../../components/FoodMenu/FoodMenu";
import PdfFlipbook from "../../components/PDF/PdfFlipbook";

const Menu = ({ setNavbarBg }) => {
  return (
    <div>
      <MenuHero setNavbarBg={setNavbarBg} />
      <FoodMenu />

      <div id="flipbook-section">
      <PdfFlipbook />
      </div>


      
    </div>
  );
};

export default Menu;